<!-- topUp.vue -->
<template>
  <div class="patient-recharge-container">
    <el-card class="recharge-card" shadow="never">
      <div slot="header" class="card-header">
        <i class="el-icon-s-help"></i>
        <span>患者健康金充值</span>
        <el-link :underline="false" @click="goToRechargeDetail" style="margin-left: auto; font-size: 13px;">
          充值明细
        </el-link>
      </div>

      <el-form :model="rechargeForm" :rules="formRules" ref="rechargeFormRef" label-width="100px" size="medium">
        <el-form-item label="选择患者" prop="phrId" required>
          <el-select
              v-model="rechargeForm.phrId"
              placeholder="请搜索选择患者 姓名/身份证号"
              filterable
              clearable
              :loading="patientLoading"
              @change="handlePatientChange"
              style="width: 100%">
            <el-option
                v-for="patient in patientList"
                :key="patient.id"
                :label="`${patient.name} - ${patient.certno} - ${patient.tel}`"
                :value="patient.id">
              <span style="float: left">{{ patient.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ patient.certno }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="充值余额">
          <el-input v-model="currentRecahrgeAmt" disabled style="width: 240px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="赠送余额">
          <el-input v-model="currentHandselAmt" disabled style="width: 240px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="支付方式" required>
          <el-select
              v-model="selectedWayId"
              placeholder="请选择支付方式"
              filterable
              clearable
              @change="handlePaymentChange"
              style="width: 240px">
            <el-option
                v-for="item in paymentMethods"
                :key="item.id"
                :label="item.wayName"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 实际充值金额 -->
        <el-form-item label="充值金额" prop="payAmount" required>
          <el-input-number
              v-model="rechargeForm.payAmount"
              :precision="2"
              :min="0.01"
              :step="10"
              placeholder="请输入充值金额"
              controls-position="right"
              style="width: 240px">
          </el-input-number>
          <span style="margin-left: 10px; color: #909399;">元</span>
        </el-form-item>

        <!-- 赠送金额 -->
        <el-form-item label="赠送金额" prop="handselAmt">
          <el-input-number
              v-model="rechargeForm.handselAmt"
              :precision="2"
              :min="0"
              :step="10"
              placeholder="请输入赠送金额"
              controls-position="right"
              style="width: 240px">
          </el-input-number>
          <span style="margin-left: 10px; color: #909399;">元</span>
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">赠送金额将额外添加到患者健康金账户</div>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
              type="textarea"
              v-model="rechargeForm.remark"
              :rows="3"
              placeholder="请输入备注信息（选填）"
              maxlength="200"
              show-word-limit
              style="width: 400px">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitRecharge" :loading="submitting">确认充值</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getPatternPaymentList } from "@/api/patternPayment/patternPayment";
import { getAmtById, phrWallet } from "@/api/patientRechargeStatistics/patientRechargeStatistics";
import { getDocphrClinicList } from "@/api/reservation/reservation";

export default {
  name: "PatientRecharge",
  data() {
    return {
      patientLoading: false,
      submitting: false,
      patientList: [],
      paymentMethods: [],
      selectedWayId: null,
      currentHandselAmt: '0.00',
      currentRecahrgeAmt: '0.00',
      rechargeForm: {
        phrId: null,
        payAmount: null,      // 实际支付金额 -> payWay.amount
        handselAmt: 0,        // 赠送金额
        remark: '',
      },
      formRules: {
        phrId: [{ required: true, message: '请选择患者', trigger: 'change' }],
        payAmount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '充值金额必须大于0', trigger: 'blur' }
        ],
        handselAmt: [
          { type: 'number', min: 0, message: '赠送金额不能为负数', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.loadPatients();
    this.loadPaymentMethods();
  },
  methods: {
    async loadPatients() {
      this.patientLoading = true;
      try {
        const res = await getDocphrClinicList({ type: 1 });
        if (res.code === 200) {
          this.patientList = res.data || [];
        } else {
          this.$message.error(res.message || '获取患者列表失败');
        }
      } catch (error) {
        console.error('获取患者列表出错:', error);
        this.$message.error('系统异常，请联系管理员');
      } finally {
        this.patientLoading = false;
      }
    },

    async handlePatientChange(patientId) {
      if (!patientId) {
        this.currentHandselAmt = '0.00';
        this.currentRecahrgeAmt = '0.00';
        this.rechargeForm.phrId = null;
        return;
      }
      try {
        const res = await getAmtById(patientId);
        if (res.code === 200 && res.data) {
          this.currentHandselAmt = (res.data.handselAmt || 0).toFixed(2);
          this.currentRecahrgeAmt = (res.data.recahrgeAmt || 0).toFixed(2);
          this.rechargeForm.phrId = patientId;
        } else {
          this.$message.error(res.message || '获取余额失败');
          this.currentHandselAmt = '0.00';
          this.currentRecahrgeAmt = '0.00';
          this.rechargeForm.phrId = null;
        }
      } catch (error) {
        console.error('获取余额失败:', error);
        this.$message.error('获取余额失败，请稍后重试');
        this.currentHandselAmt = '0.00';
        this.currentRecahrgeAmt = '0.00';
        this.rechargeForm.phrId = null;
      }
    },

    async loadPaymentMethods() {
      try {
        const res = await getPatternPaymentList();
        if (res.code === 200) {
          this.paymentMethods = (res.data || []).filter(item => item.status === 1);
        } else {
          this.$message.error(res.message || '获取支付方式失败');
        }
      } catch (error) {
        console.error('获取支付方式出错:', error);
        this.$message.error('系统异常，请联系管理员');
      }
    },

    handlePaymentChange(wayId) {
      this.selectedWayId = wayId;
    },

    async submitRecharge() {
      let valid = false;
      try {
        await this.$refs.rechargeFormRef.validate();
        valid = true;
      } catch (e) {
        this.$message.warning('请完善表单信息');
        return;
      }
      if (!valid) return;

      if (this.rechargeForm.payAmount <= 0) {
        this.$message.warning('充值金额必须大于0');
        return;
      }
      if (this.rechargeForm.handselAmt < 0) {
        this.$message.warning('赠送金额不能为负数');
        return;
      }

      const selectedPayment = this.paymentMethods.find(p => p.id === this.selectedWayId);
      if (!selectedPayment) {
        this.$message.warning('请选择有效的支付方式');
        return;
      }

      // 按照接口要求构造数据
      const requestData = {
        phrId: this.rechargeForm.phrId,
        handselAmt: this.rechargeForm.handselAmt || 0,
        remark: this.rechargeForm.remark || '',
        payWay: {
          amount: this.rechargeForm.payAmount,
          classId: selectedPayment.classId,
          uniCode: selectedPayment.uniCode,
          wayId: selectedPayment.id
        }
      };

      this.submitting = true;
      try {
        const res = await phrWallet(requestData);
        if (res.code === 200) {
          this.$message.success('充值成功');
          if (this.rechargeForm.phrId) {
            const balanceRes = await getAmtById(this.rechargeForm.phrId);
            if (balanceRes.code === 200 && balanceRes.data) {
              this.currentHandselAmt = (balanceRes.data.handselAmt || 0).toFixed(2);
              this.currentRecahrgeAmt = (balanceRes.data.recahrgeAmt || 0).toFixed(2);
            }
          }
          this.resetForm();
        } else {
          this.$message.error(res.message || '充值失败');
        }
      } catch (error) {
        console.error('充值请求失败:', error);
        this.$message.error('系统异常，请稍后重试');
      } finally {
        this.submitting = false;
      }
    },

    resetForm() {
      this.rechargeForm = {
        phrId: null,
        payAmount: null,
        handselAmt: 0,
        remark: ''
      };
      this.selectedWayId = null;
      this.currentHandselAmt = '0.00';
      this.$refs.rechargeFormRef && this.$refs.rechargeFormRef.resetFields();
    },

    goToRechargeDetail() {
      this.$router.push('/patientRechargeStatistics/patientRechargeStatistics');
    }
  }
};
</script>

<style scoped lang="less">
.patient-recharge-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.recharge-card {
  width: 700px;
  max-width: 90%;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  justify-content: space-between;

  i {
    font-size: 20px;
    margin-right: 8px;
    color: #409EFF;
  }
}

/deep/ .el-form-item__label {
  font-weight: 500;
}

/deep/ .el-input-number {
  width: 200px;
}

/deep/ .el-textarea {
  width: 400px;
}

@media (max-width: 768px) {
  .recharge-card {
    width: 95%;
  }
  /deep/ .el-textarea,
  /deep/ .el-input-number {
    width: 100%;
  }
}
</style>